<template>
<div class="pdf" v-show="false">
    
     <div>
        {{currentPage}} / {{pageCount}}
        <pdf
            :src="src"
            :page="page"
            @num-pages="pageCount = $event"
            @page-loaded="currentPage = $event"
        ></pdf>
        <va-button @click="mais_pagina()">Mais</va-button> 
        <va-button color="info" @click="menos_pagina()">Menos</va-button> 

        <iframe src="https://docs.google.com/gview?url=http://remote.url.tld/path/to/document.doc&embedded=true"></iframe>
    </div>
</div>
    
</template>
<script>
var loadingTask = 'https://cdn.rawgit.com/mozilla/pdf.js/c6e8ca86/test/pdfs/freeculture.pdf';
import pdf from 'vue-pdf'
export default {
    name:'preloader',
    components: {
        pdf
    },
    data() {
        return {
            src: loadingTask,
            currentPage: 0,
            pageCount: 0,
            page:1
        }
    },
    computed: {
        pdfvi(){
            return this.$store.state.preloader.pdf
        }
    },
    methods:{
      mais_pagina(){
        this.page++
      },
      menos_pagina(){
        this.page--
      }

    }
}
</script>

<style  scoped>
.pdf{
background:#000;
position: absolute;
z-index: 9999;
opacity: .2;
width: 100%;
height: 100%;
margin: 0;
text-align: center;
padding: 20% 0
}
.pdf img{
    max-width: 100%
}
</style>